import { ButtonHTMLAttributes } from 'react';
import { twc } from 'react-twc';

import { cn } from '@/utils/twx';

import { CommonButton } from './CommonButton';

const BaseTonalButton = twc(CommonButton)`${cn(
  'transition-all bg-opacity-20',
  'hover:bg-opacity-40',
  'disabled:bg-opacity-20 disabled:cursor-not-allowed disabled:hover:bg-opacity-20',
)}`;

const PrimaryButton = twc(BaseTonalButton)`text-primary bg-primary`;

const SecondaryButton = twc(BaseTonalButton)`text-secondary bg-secondary`;

const GrayButton = twc(BaseTonalButton)` bg-gray-3`;

interface TonalButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'primary' | 'secondary' | 'gray';
}

const TonalButton = ({ color, ...props }: TonalButtonProps) => {
  switch (color) {
    case 'primary':
      return <PrimaryButton {...props} />;
    case 'secondary':
      return <SecondaryButton {...props} />;
    case 'gray':
      return <GrayButton {...props} />;
    default:
      return <BaseTonalButton {...props} />;
  }
};

export default TonalButton;
